import { Table } from "reactstrap";
const CandidateBillingCredit = ({ netCommission, recruiters }) => {
  return (
    <div className="candidtae-bcredit-ssheet">
      <h5 className="mb-2">Candidate Billing Credit</h5>

      <Table className="transparentTable">
        <thead>
          <tr>
            <th style={{ width: "36%" }}>Name</th>
            <th style={{ width: "64%" }}>Credit%</th>
          </tr>
        </thead>

        <tbody>
          {recruiters?.length > 0 &&
            recruiters?.map((item) => {
              return (
                <tr>
                  <td>{item?.user?.fullName}</td>

                  <td>{item?.splitPercentage}%</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
};

export default CandidateBillingCredit;
